import {
  Box,
  Skeleton,
  Stack,
  Typography
} from '@mui/material';

import { StyledTextChip } from 'modules/components/layer01';
import { useMemo } from 'react';
import { theme } from 'theme';



export type DataMetricProps = {
  name: string;
  percentChangeMoM: number;
  value: number;
  loading?: boolean;
};

export const FC = (props: DataMetricProps) => {
  const displayUnit = useMemo(() => {
    if (props.value > 1_000_000_000_000) {
      return 'T';
    } else if (props.value > 1_000_000_000) {
      return 'B';
    } else if (props.value > 1_000_000) {
      return 'M';
    } else if (props.value > 10_000) {
      return 'K';
    }

    return '';
  }, [props.value]);

  const value = useMemo(() => {
    if (props.value > 1_000_000_000_000) {
      return (props.value / 1_000_000_000_000).toFixed(1);
    } else if (props.value > 1_000_000_000) {
      return (props.value / 1_000_000_000).toFixed(1);
    } else if (props.value > 1_000_000) {
      return (props.value / 1_000_000).toFixed(1);
    } else if (props.value > 10_000) {
      return (props.value / 1000).toFixed(2);
    }

    return props.value.toLocaleString('en-US', {
      useGrouping: true
    });
  }, [props.value]);

  return (
    (
      <Box
        padding='.5rem .75rem .75rem .75rem'
        display='flex'
        flex='1 1 0'
        flexDirection='column'
        justifyContent='space-between'
        borderRadius='.5rem'
        rowGap='.5rem'
      >
        <Typography variant='summaryMetricName'>{props.name}</Typography>
        <Stack
          direction='row'
          alignItems='start'
        >
          {!props.loading
            ? (
              <Typography
                variant='summaryMetricValue'
                color={props.percentChangeMoM >= 0 ? theme.palette.primary.main : theme.palette.error.main}
              >
                {value}
              </Typography>
            )
            : (
              <Skeleton sx={{
                minWidth: 100
              }}
              />
            )}

          {!props.loading && (
            <Typography
              variant='h4'
              color={props.percentChangeMoM >= 0 ? theme.palette.primary.main : theme.palette.error.main}
            >
              {displayUnit}
            </Typography>
          )}
        </Stack>
        <Box flexGrow={-1}>
          {props.loading
            ? (
              <Skeleton sx={{
                minWidth: 100
              }}
              />
            )
            : (
              <StyledTextChip.FC
                upIsGood
                label={props.percentChangeMoM.toLocaleString('en-US', {
                  useGrouping: true,
                  maximumFractionDigits: 2
                })}
                type={props.percentChangeMoM >= 0 ? 'STAT_INCREASE' : 'STAT_DECREASE'}
              />
            )}
        </Box>
      </Box>
    )
  );
};
